
import defaults from '~/assets/organisationTypePickerDefaults.json'

export default {
  props: {
    slice: {
      type: Object,
      required: true,
    },
  },
  computed: {
    items() {
      if (!this.slice.items || this.slice.items.length === 0) return defaults

      return this.slice.items.map((item) => {
        return {
          cta_text: item.cta_text,
          link: this.getLink(item),
          image: this.getImage(item),
        }
      })
    },
  },
  methods: {
    getLink(field) {
      if (field.cta_link) return field.cta_link

      const defaultField = defaults.find(
        (item) => field.cta_text?.toLowerCase() === item.cta_text?.toLowerCase()
      )
      return defaultField ? defaultField.link : '/'
    },
    getImage(field) {
      const hasImage = Object.keys(field.icon).length > 0

      if (hasImage) return field.icon.url

      const defaultField = defaults.find(
        (item) => field.cta_text?.toLowerCase() === item.cta_text?.toLowerCase()
      )
      return defaultField
        ? require(`~/assets/images/${defaultField.image}`)
        : require(`~/assets/images/building.svg`)
    },
  },
}
